import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Configuracion from '../views/Configuracion.vue'
import ListaConceptos from '../components/Conceptos/ListaConceptos.vue'
import ListaTrabajadores from '../components/Trabajadores/ListaTrabajadores.vue'
import ListaNomina from '../components/Nomina/ListaNomina.vue'
import Reportes from '../components/Reportes/Reportes.vue'

import Login from '../views/Login.vue'
import store from '../store/index'

Vue.use(VueRouter)

const routes = [
  { path: '/Login', name: 'Login', component: Login, meta: { libre: true } },
  { path: '/', name: 'Home', component: Home, meta: { Administrador: true } },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue') },
  { path: '/Configuracion', name: 'Configuracion', component: Configuracion, meta: { Administrador: true } },
  { path: '/ListaConceptos', name: 'ListaConceptos', component: ListaConceptos, meta: { Administrador: true } },
  { path: '/ListaTrabajadores', name: 'ListaTrabajadores', component: ListaTrabajadores, meta: { Administrador: true } },
  { path: '/ListaNomina', name: 'ListaNomina', component: ListaNomina, meta: { Administrador: true } },
  { path: '/Reportes', name: 'Reportes', component: Reportes, meta: { Administrador: true } },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.libre)) {
    next()
  } else if (store.state.usuario && store.state.usuario.rol == 'Administrador') {
    if (to.matched.some(record => record.meta.Administrador)) {
      next()
    }
  } else {
    next({
      name: 'Login'
    })
  }
})

export default router
